import React from 'react';
import ProcessingStatus from './ProcessingStatus';

/**
 * UpdatingBar — kept for its callers (Signal Analysis, Quarterly Wins); it is
 * the shared ProcessingStatus strip now, so every page shows processing the
 * same way (Apal 2026-11-02). Mounted only while loading.
 */
const UpdatingBar = ({ label = 'Updating results', what, className = '' }) => {
  const title = label.replace(/\.{3}$|…$/, '');
  // one wording on every page: a refresh is "Updating results"
  return <ProcessingStatus active title={title === 'Updating' ? 'Updating results' : title} what={what} className={className} testId="updating-bar" />;
};

export default UpdatingBar;
